import {
  CatalogQueryType,
  CatalogSearchResultData,
  CatalogSearchResultItem,
  ResourceCatalogComponent,
  ResourceCatalogComponentPaged,
} from './types';

import { DevHubGrid, DevHubLink } from '@devxdiscover/devhub-ui';
import { getOwnerForEntity } from '@devxdiscover/devhub-common';

/**
 * ComponentResult - Returns component details for the search results
 * @param data row containing data for the component
 */
export const ComponentDetails = (data: CatalogSearchResultItem) => {
  const componentData = data.item as ResourceCatalogComponent;
  return (
    <DevHubGrid container>
      <DevHubGrid item xs={1} />
      <DevHubGrid container item xs={11} spacing={1}>
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>Description</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          {componentData.description}
        </DevHubGrid>
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>Repository</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          <DevHubLink href={componentData.sourceLocationUrl} target="_blank">
            {componentData.sourceLocationUrl}
          </DevHubLink>
        </DevHubGrid>
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>ID</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          {componentData.id}
        </DevHubGrid>
      </DevHubGrid>
    </DevHubGrid>
  );
};

/**
 * convertComponentSearchResult - Convert the component search result to the catalog result data
 * @param componentData - The component data
 * @param componentType - The component type
 */
export const convertComponentSearchResult = (
  componentData: ResourceCatalogComponentPaged,
  componentType: CatalogQueryType.Component | CatalogQueryType.TechDocs,
): CatalogSearchResultData => {
  const componentItems: CatalogSearchResultItem[] = (
    componentData.resources.componentsPaged
      .components as ResourceCatalogComponent[]
  ).map(item => {
    return {
      expandable: false,
      name: item.name,
      id: item.id,
      applicationsPaged: item.applicationsPaged,
      type: componentType,
      lifecycle: item.lifecycle,
      description: item.description,
      ownerOrg:
        getOwnerForEntity(item)?.replace(/^(?:user|group):/i, '') ?? 'comcast',
      item: item,
    };
  });

  return {
    items: componentItems,
    totalCount: componentData.resources.componentsPaged.totalCount,
  };
};
